import { isJSONTreatment, useFeatureFlag } from '@moda/portal-stanchions';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useCookies } from '../../hooks/useCookies';

type Slug = string;
type Restriction = string;
type Restrictions = Restriction[];

type GuidePageRestrictionsFeatureFlag = null | Record<Slug, Restrictions>;

export const useGuidePageRestrictions = () => {
  const { guideSlug } = useParams<{ guideSlug: string }>();
  const {
    cookies: { cloudfrontViewerCountry: viewerCountry }
  } = useCookies();

  const treatment = useFeatureFlag<GuidePageRestrictionsFeatureFlag>('guide-page-restrictions', [
    {
      default: {}
    },
    {
      getFromTreatment: treatment =>
        isJSONTreatment(treatment) ? (treatment as GuidePageRestrictionsFeatureFlag) : {}
    }
  ]);

  const restricted = useMemo(() => {
    if (!treatment) return false;

    if (!treatment[guideSlug]) return false;

    const allowedCountries = treatment[guideSlug];

    if (allowedCountries.find(country => country === viewerCountry)) return false;

    return true;
  }, [guideSlug, treatment, viewerCountry]);

  return { restricted };
};
